import { gsap } from '/shared.js';



/**
 * Logos entrance
 */

const allLogos = document.querySelectorAll('.clients-area .client-item');
const logosTl = gsap.timeline({
    scrollTrigger: {
        trigger: '.clients-list',
        start: 'top 80%',
        // end: 'bottom 60%',

    }

});

logosTl.from(allLogos, { y: 50, opacity: 0, stagger: 0.2, duration: .3, ease: "power2.out" });
